import Vue from 'vue'
import VueGtag from 'vue-gtag';
import App from './App.vue'
import store from './store/index'
import './registerServiceWorker'
import router from './router'
import RedirectOneDriveButton from './components/RedirectOneDriveButton.vue'
import './styles/video-player.scss'  

Vue.config.productionTip = false
Vue.component('RedirectOneDriveButton', RedirectOneDriveButton)

const gtag_id = process.env.VUE_APP_GTAG_ID

if (gtag_id) {
  Vue.use(VueGtag, {
    config: { id: gtag_id },
    }, router,
  );
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

